import { requst } from '../config'

/* ====================================== 项目基础信息接口 ===================================================== */
/* 提交 ProjectBase 数据 */
export const putProjectBaseApi = params => {
    const url = `/setting/project/editBase`
    return requst.put(url, { ...params })
}

/* 获取 ErpList 数据 */
export const getErpList = () => {
    const url = `/setting/project/queryErpList`
    return requst.get(url)
}

/* 获取 Geometry OBN 数据 */
export const getGeometryOBNApi = projectId => {
    const url = `/setting/geometry/obn/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Geometry OBN 数据 */
export const putGeometryOBNApi = params => {
    const url = `/setting/geometry/obn/addOrUpdate`
    return requst.post(url, { ...params })
}
/* 获取 Geometry Streamer 数据 */
export const getGeometryStreamerApi = projectId => {
    const url = `/setting/geometry/steamer/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Geometry Streamer 数据 */
export const putGeometryStreamerApi = params => {
    const url = `/setting/geometry/steamer/addOrUpdate`
    return requst.post(url, { ...params })
}

/* 获取 Workload OBN 数据 */
export const getWorkloadOBNApi = projectId => {
    const url = `/setting/workload/obn/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Workload OBN 数据 */
export const putWorkloadOBNApi = params => {
    const url = `/setting/workload/obn/addOrUpdate`
    return requst.post(url, { ...params })
}
/* 获取 Workload Streamer 数据 */
export const getWorkloadStreamerApi = projectId => {
    const url = `/setting/workload/steamer/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Workload Streamer 数据 */
export const putWorkloadStreamerApi = params => {
    const url = `/setting/workload/steamer/addOrUpdate`
    return requst.post(url, { ...params })
}

/* ====================================== Streamer接口 ===================================================== */
/* 提交 Streamer 数据 */
export const postStreamerApi = params => {
    const url = `/project/streamer/config/save`
    return requst.post(url, params)
}
/* 获取 Streamer 数据 */
export const getStreamerApi = projectId => {
    const url = `/project/streamer/config/${projectId}`
    return requst.get(url)
}
/* ====================================== 甲方信息接口 ===================================================== */
/* 获取 Client 数据 */
export const getClientApi = projectId => {
    const url = `/setting/client/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Client 数据 */
export const postClientApi = params => {
    const url = `/setting/client/addOrUpdate`
    return requst.post(url, { ...params })
}

/* ====================================== 甲监信息接口 ===================================================== */
/* 获取 clientDetails 数据 */
export const getClientDetailsApi = projectId => {
    const url = `/setting/clientRep/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 clientDetails 数据 */
export const postClientDetailsApi = params => {
    const url = `/setting/clientRep/addOrUpdate`
    return requst.post(url, { ...params })
}
/* 提交 clientDetails 单条表格数据 */
export const postClientDetailsTableDataApi = params => {
    const url = `/setting/clientRep/staff`
    return requst.post(url, { ...params })
}
/* 修改 clientDetails 单条表格数据 */
export const putClientDetailsTableDataApi = params => {
    const url = `/setting/clientRep/staff`
    return requst.put(url, { ...params })
}
/* 获取 clientDetails 表格数据 */
export const getClientDetailsTableDataApi = projectId => {
    const url = `/setting/clientRep/staff/list?projectId=${projectId}`
    return requst.get(url)
}
/* 删除 clientDetails 表格单条数据 */
export const deletClientDetailsTableDataApi = id => {
    const url = `/setting/clientRep/staff/${id}`
    return requst.delete(url)
}

/* ====================================== 乙方信息接口 ===================================================== */
/* 获取 Crew 数据 */
export const getCrewApi = projectId => {
    const url = `/setting/contractor/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Crew 数据 */
export const postCrewApi = params => {
    const url = `/setting/contractor/addOrUpdate`
    return requst.post(url, { ...params })
}

/* ====================================== 施工队信息接口 ===================================================== */
/* 获取 CrewDetails 数据 */
export const getCrewDetailsApi = projectId => {
    const url = `/setting/contractor/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 CrewDetails 数据 */
export const postCrewDetailsApi = params => {
    const url = `/setting/contractor/addOrUpdate`
    return requst.post(url, { ...params })
}
/* 获取 CrewDetails 表格数据 */
export const getCrewDetailsTableDataApi = projectId => {
    const url = `/setting/contractor/staff/list?projectId=${projectId}`
    return requst.get(url)
}
/* 提交 CrewDetails 表格单条数据 */
export const postCrewDetailsTableDataApi = params => {
    const url = `/setting/contractor/staff`
    return requst.post(url, { ...params })
}
/* 修改 CrewDetails 表格单条数据 */
export const putCrewDetailsTableDataApi = params => {
    const url = `/setting/contractor/staff`
    return requst.put(url, { ...params })
}
/* 删除 CrewDetails 表格单条数据 */
export const deletCrewDetailsTableDataApi = id => {
    const url = `/setting/contractor/staff/${id}`
    return requst.delete(url)
}

/* ====================================== 地形设置接口 ===================================================== */
/* 提交 TerrainSetting 数据 */
export const postTerrainSettingApi = params => {
    const url = `/setting/terrain/save`
    return requst.post(url, { ...params })
}
/* 获取 TerrainSetting 表格数据 */
export const getTerrainSettingTableDataApi = projectId => {
    const url = `/setting/terrain/listAll?projectId=${projectId}`
    return requst.get(url)
}
/* 删除 TerrainSetting 表格单条数据 */
export const deletTerrainSettingTableDataApi = id => {
    const url = `/setting/terrain/delete/?id=${id}`
    return requst.delete(url)
}

/* ====================================== 点距离设置接口 ===================================================== */
/* 提交 vpIntervalSetting 数据 */
export const postVpIntervalSettingApi = params => {
    const url = `/vpIntervalSetting/save`
    return requst.post(url, { ...params })
}
/* 获取 vpIntervalSetting 表格数据 */
export const getVpIntervalSettingTableDataApi = projectId => {
    const url = `/vpIntervalSetting/listAll?projectId=${projectId}`
    return requst.get(url)
}
/* 删除 vpIntervalSetting 表格单条数据 */
export const deletVpIntervalSettingTableDataApi = id => {
    const url = `/vpIntervalSetting/delete/?id=${id}`
    return requst.delete(url)
}

/* ====================================== 录制信息接口 ===================================================== */
/* 获取 Recording 数据 */
export const getRecordingApi = projectId => {
    const url = `/setting/recording/projectId/${projectId}`
    return requst.get(url)
}
/* 提交 Recording 数据 */
export const postRecordingApi = params => {
    const url = `/setting/recording/addOrUpdate`
    return requst.post(url, { ...params })
}

/* ====================================== 接收信息接口 ===================================================== */
/* 获取 Receiver 数据 */
export const getReceiverApi = projectId => {
    const url = `/setting/receiver/listAll?projectId=${projectId}`
    return requst.get(url)
}
/* 提交 Receiver 数据 */
export const postReceiverApi = params => {
    const url = `/setting/receiver/save`
    return requst.post(url, { ...params })
}
/* 删除 Receiver 表格单条数据 */
export const deletReceiverTableDataApi = id => {
    const url = `/setting/receiver/${id}`
    return requst.delete(url)
}

/* ====================================== 激发信息接口 ===================================================== */
/* 获取 Source list 数据 */
export const getSourceListApi = projectId => {
    const url = `/setting/source/airgun/list/${projectId}`
    return requst.get(url)
}

/* 获取 震源 list 数据 */
export const getScanListApi = projectId => {
    const url = `/setting/source/quake/listAll?projectId=${projectId}`
    return requst.get(url)
}

/* 获取 炸药 list 数据 */
export const getExplosiveListApi = projectId => {
    const url = `/setting/source/explosive/listAll?projectId=${projectId}`
    return requst.get(url)
}


/* 获取单个 Source 数据 */
export const getSourceIdApi = id => {
    const url = `/setting/source/airgun/${id}`
    return requst.get(url)
}

/* 删除单个 Source 数据 */
export const deleteSourceIdApi = id => {
    const url = `/setting/source/airgun/${id}`
    return requst.delete(url)
}

/* 删除单个 震源激发 数据 */
export const deleteScanIdApi = id => {
    const url = `/setting/source/quake/delete?id=${id}`
    return requst.delete(url)
}

/* 删除单个 炸药 数据 */
export const deleteExplosiveIdApi = id => {
    const url = `/setting/source/explosive/delete?id=${id}`
    return requst.delete(url)
}

/* 提交 Source 数据 */
export const postSourceApi = params => {
    const url = `/setting/source/airgun/addOrUpdate`
    return requst.post(url, { ...params })
}

/* 提交 震源激发 数据 */
export const postquakeSourceApi = params => {
    const url = `/setting/source/quake/save`
    return requst.post(url, { ...params })
}

/* 提交 炸药 数据 */
export const postExplosiveApi = params => {
    const url = `/setting/source/explosive/save`
    return requst.post(url, { ...params })
}

/* 提交 项目投入震源台数 数据 */
export const postVibsApi = params => {
    const url = `/setting/project/saveContractVibsNumber?projectId=${params.projectId}&vibsNumber=${params.vibsNumber}`
    return requst.post(url, {})
}

// 删除 震源 数据
export const deleteFileDataApi = params => {
    const url = `/quake/source/clear?produceDate=${params.produceDate}&projectId=${params.projectId}`
    return requst.delete(url)
}


/* ====================================== 目标日效配置接口 ===================================================== */

/* 提交 DailyProduction 数据 */
export const postDailyProductionApi = params => {
    const url = `/setting/targetDailyProduction/saveBatch`
    return requst.post(url, { ...params })
}

/* 获取 DailyProduction 数据 */
export const getDailyProductionApi = projectId => {
    const url = `/setting/targetDailyProduction/listAll?projectId=${projectId}`
    return requst.get(url)
}
